import React, { type FC } from 'react';
import { VIEW_RESOLVER } from '@/data/constants';
import { IPageLayout } from './page-layout.interface';
import { ViewResolverSection } from '@/packages/ldp-core-sdm/src/components';

const PageLayoutSSR: FC<IPageLayout> = () => {
  const { API_VERSION_V2: apiVersion, MAIN_CONTENT_COLLECTION } = VIEW_RESOLVER;

  return (
    <ViewResolverSection apiVersion={apiVersion} layoutSection={MAIN_CONTENT_COLLECTION} />
  );
};

export default PageLayoutSSR;
